import { useMutation } from '@tanstack/react-query';
import LangEnum from '../../lang/LangEnum';
import snackbarStore from '../../stores/Snackbar.store';
import { useTranslation } from '../translation/TranslationContext';
import NpsRepository from './nps.repository';
import { CreateNpsBody } from './nps.types';

export const useCreateNpsMutation = () => {
  const { translate } = useTranslation();
  const { handleMessage } = snackbarStore;

  const { isPending, mutate: createNps } = useMutation({
    mutationFn: async (body: CreateNpsBody) => {
      const response = await NpsRepository.createNps(body);
      if (!response.ok) {
        throw response.originalError ?? new Error('createNps failed');
      }
    },
    onSuccess: () => {
      handleMessage({
        type: 'success',
        message: translate(LangEnum.GLOBAL_SUCCESS_ON_CREATE_USER_ANSWER),
      });
    },
    onError: () => {
      handleMessage({ type: 'error', message: translate(LangEnum.GLOBAL_ERROR_ON_SEND_ANSWER) });
    },
  });

  return { createNps, isPending };
};
